import { OUI_NON } from '../model';

export default factory;

function factory() {
  return (value) => {
    switch (value) {
      case OUI_NON.OUI:
        return 'Oui';
      case OUI_NON.NON:
        return 'Non';
      default:
        return '';
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/common/filters/oui-non.filter.js